import { sortableEntitySchema } from './sortable-entity.js';
import { IllegalArgumentError } from 'faro-common-model';
import { StudyEntityType } from './study-entity-type.js';
import { z } from 'zod';
import { uuidish } from '../utils/uuidish.js';
import { nullishToEmptyArray } from '../utils/nullishToEmptyArray.js';
export const activityFootnoteTextMaxLength = 2000;
export const activityFootnoteSchema = z.object({
    ...sortableEntitySchema.shape,
    entityType: z.literal(StudyEntityType.ActivityFootnote).default(StudyEntityType.ActivityFootnote),
    scheduleOfActivitiesId: uuidish,
    activityIds: z.array(uuidish).nullish().transform(nullishToEmptyArray),
    text: z.string().max(activityFootnoteTextMaxLength),
});
export function toActivityFootnote(footnote) {
    const result = activityFootnoteSchema.safeParse(footnote);
    if (!result.success) {
        throw new IllegalArgumentError(`Invalid ActivityFootnote object. ${result.error.message}`);
    }
    return result.data;
}
//# sourceMappingURL=activity-footnote.js.map